import { Row, Col } from "antd";
import React from "react";
import { TTranslate } from "../../../core/service/locale/TranslationService";
import HeadingLabel from "../../../core/ui/components/HeadingLabel";
import { TSearchQueryPresentationModel } from "../../model/SearchQueryPresentationModel";

export interface Props {
  translate: TTranslate;
  loading?: boolean;
  query?: TSearchQueryPresentationModel;
}

const SearchCriteriaSummaryCard: React.FC<Props> = ({
  translate,
  loading = false,
  query
}: Props) => {
  if (loading || !query || Object.keys(query).length === 0) {
    return null;
  }
  let items = Object.keys(query).map((key) =>
    query[key]?.description ? (
      <>
        <span
          style={{
            color: "#08749B",
            fontWeight: 500,
            display: "contents",
            marginRight: 5
          }}
        >
          {`${query[key]?.label}:`}
        </span>
        <span style={{ marginLeft: 5, fontSize: 13 }}>
          {query[key]?.description}
        </span>
      </>
    ) : null
  );
  let separator = <span> </span>;
  let result = [...items]
    .map((e, i) => (i < items.length - 1 ? [e, separator] : [e]))
    .reduce((a, b) => a.concat(b));
  return (
    <Row className={"search-result"}>
      <Col xs={24} sm={24}>
        <Row style={{ marginBottom: 12 }}>
          <HeadingLabel
            text={translate("editors.case_law_documents.search_criteria")}
          ></HeadingLabel>
        </Row>
        <Row>
          <Col span={24}>
            {result.map((item, index) => (
              <span key={`criteria-summary-${index}`}>{item}</span>
            ))}
          </Col>
        </Row>
      </Col>
    </Row>
  );
};

export default SearchCriteriaSummaryCard;
